import {createSlice} from "@reduxjs/toolkit";

const initialLinksState = {
  listLoading: false,
  actionsLoading: false,
  sellersLoading: false,
  totalCount: 0,
  linkList: null,
  link: undefined,
  lastError: null,
  sellerList: null,
  sellerCount: 0,
};

export const callTypes = {
  list: "list",
  action: "action",
  sellers: "sellers",
};

export const linksSlice = createSlice({
  name: "links",
  initialState: initialLinksState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.sellers) {
        state.sellersLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.sellers) {
        state.sellersLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findLinks
    linksFetched: (state, action) => {
      const { totalCnt, saleLinkList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.linkList = saleLinkList;
      state.totalCount = totalCnt;
    },
    // getLinkById
    linkFetched: (state, action) => {
      const {link} = action.payload;
      state.actionsLoading = false;
      state.link = link;
      state.error = null;
    },
  }
});
